import type { Locale } from '@i18n/config';

/**
 * The `error` strings `global-error.tsx` shows, inlined so the page renders
 * even when chunk loading is what broke. Must match `error.title`,
 * `error.description` and `error.retry` in messages/en.json and es.json
 * (a unit test checks).
 */
export const GLOBAL_ERROR_MESSAGES: Record<
  Locale,
  { error: { title: string; description: string; retry: string } }
> = {
  en: {
    error: {
      title: 'Oops! Something went wrong',
      description:
        'Please try again later or contact support if the problem persists.',
      retry: 'Try again'
    }
  },
  es: {
    error: {
      title: '¡Vaya! Algo salió mal',
      description:
        'Inténtalo de nuevo más tarde o contacta con soporte si el problema continúa.',
      retry: 'Intentar de nuevo'
    }
  }
};
